import ProgressLoader, { ProgressLoader2 } from "./loader";

export default ProgressLoader;
export { ProgressLoader2 };
